import React from 'react';
import { DRVBundGlobals } from '@zs21/drv-bund-common-ilias-utils';
import { Box, Card, Typography } from '@mui/material';
import { formatDate } from './helper/dateHelper';

const CourseHeader = ({ courseData, color }) => {
	const headerSize = '150px'; //TODO: find appropriate size
	const imageUrl = DRVBundGlobals.ENV_VARS.get('EDUCATION_CATALOGUE_CATEGORY_IMAGES_URL');
	const categoryColor = courseData.categorization?.subCategory?.color || courseData.categorization?.category?.color || courseData.categorization?.topic?.color || '#D6DC32';
	const categoryIcon = (() => {
		if (courseData.categorization.category?.iconImg) {
			return true;
		}
	})();
	const categoryIconSrc = courseData.categorization.category?.iconImg && `${imageUrl}/${courseData.categorization.category.iconImg}`;
	const startDate = formatDate(courseData.validFrom);
	const endDate = formatDate(courseData.validUntil);
	const cancelled = courseData.status === 'abgesagt';

	return (
		<Card
			sx={{
				borderRadius: '10px',
				boxShadow: 2,
				maxWidth: '100%',
				height: headerSize,
				padding: '0 0 0 2rem',
				'@container course-info (max-width: 600px)': {
					padding: '0 0 0 1rem',
				},
			}}>
			<Box
				sx={{
					height: '100%',
					display: 'grid',
					gridTemplateColumns: 'minmax(0, 9fr) 1fr',
					gridTemplateRows: 'minmax(0, 2fr) minmax(0, 1fr)',
					gridTemplateAreas: `
						"title category"
						"date category"`,
					'@container course-info (max-width: 600px)': {
						gridTemplateAreas: `
							"title category"
							"date date"`,
					},
				}}>
				<Typography
					sx={{
						gridArea: 'title',
						alignSelf: 'center',
						color: color,
						'@container course-info (max-width: 600px)': {
							fontSize: '1.5rem',
							paddingTop: '.75rem',
							paddingBottom: 0,
						},
						'@container course-info (max-width: 960px)': {
							paddingTop: '1rem',
							paddingBottom: 0,
						},
						fontSize: 'clamp(1.75rem, 2cqi + 1rem, 2.25rem)',
						lineHeight: 1.1,
						paddingBottom: 'clamp(.5rem, .75rem, 1.5rem)',
						paddingTop: 'clamp(1rem, 1.25rem, 1.5rem)',
						paddingRight: 'clamp(.5rem, 1rem, 1rem)'
					}}>
					{courseData.title}
					<span style={{
						fontSize: '1rem',
						fontWeight: 'normal',
						paddingLeft: 'clamp(.5rem, 1rem, 1rem)'
					}}>{`(${courseData.short})`}</span>
				</Typography>
				<Typography
					sx={{
						gridArea: 'date',
						alignSelf: 'center',
						'@container course-info (max-width: 600px)': {
							fontSize: '1rem',
						},
						fontSize: 'clamp(1rem, 1.125rem, 1.25rem)',
						fontWeight: 'medium',
						color: color,
						'@container course-info (max-width: 960px)': {
							paddingBottom: 'clamp(.25rem, .5rem, 1rem)',
						},
						paddingBottom: 'clamp(.5rem, 1.25rem, 1.5rem)',
					}}>
					<span style={{
						paddingRight: '2rem',
						textDecoration: cancelled ? 'line-through' : 'none'
					}}>{`${startDate}–${endDate}`}</span>
					{
						cancelled &&
						<span style={{
							color: 'white',
							fontSize: '1rem',
							fontWeight: 'bold',
							padding: '.5rem 1.25rem',
							borderRadius: '10px',
							background: '#DD0000 0% 0% no-repeat padding-box',
						}}>ABGESAGT</span>
					}
				</Typography>
				<Box
					sx={{
						display: 'grid',
						gridArea: 'category',
						bgcolor: categoryColor,
						marginLeft: 'auto',
						'@container course-info (max-width: 600px)': {
							maxWidth: `calc(${headerSize} / 2)`,
							width: `calc(${headerSize} / 2)`,
							aspectRatio: 1,
							borderBottomLeftRadius: '10px',
						},
						maxWidth: headerSize,
						width: headerSize,
						padding: '20%',
					}}
					aria-label='Grafik der Themenkategorie'
				>
					{
						categoryIcon ?
						<img src={categoryIconSrc}
							 style={{
								 filter: 'brightness(0) invert(1)',
								 maxHeight: '4.375rem',
								 aspectRatio: 1,
								 placeSelf: 'center',
							 }}
							 alt='Grafik der Themenkategorie' />
							: null
					}
				</Box>
			</Box>
		</Card>
	);
};

export { CourseHeader };







